var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.770585,17.7445195 L13.3758184,3.77868927 C13.0828557,3.2910542 12.5685009,3 11.9997523,3 C11.4310038,3 10.916649,3.2910542 10.6246405,3.777735 L2.22891968,17.7445195 C1.93118555,18.2397888 1.92355134,18.859114 2.20792561,19.3620175 C2.4913456,19.864921 3.02669447,20.1769692 3.60498577,20.1769692 L20.3954732,20.1769692 C20.9728102,20.1769692 21.5091134,19.864921 21.7925334,19.3620175 C22.0769076,18.859114 22.0683191,18.2397888 21.770585,17.7445195 Z M12.6804819,17.4398804 L10.7719298,17.4398804 L10.7719298,15.5313283 L12.6804819,15.5313283 L12.6804819,17.4398804 Z M12.6804819,14.0370445 L10.7719298,14.0370445 L10.7719298,9.26566415 L12.6804819,9.26566415 L12.6804819,14.0370445 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a4f3a0b8bb57b2565e98c30fc247990b.svg";
export { ForwardRef as ReactComponent };